import AuthorizeForm from './AuthorizeForm';

export default AuthorizeForm;
